/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:messageId
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/02 | 富士通株式会社         | 新規作成
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
//================================================================================
 */
// メッセージ用定義
export const MSG_ALPHA_NUM = '半角英数文字';
export const MSG_DECIMAL = '数値（整数@1桁、小数@2桁）';
export const MSG_FULL_STR = '全角文字';
export const MSG_HALF_NUM = '数字';
export const MSG_HALF_STR = '半角文字';
export const MSG_HALF_KANA = 'カタカナ';
export const MSG_HIRAGANA = 'ひらがな';
export const MSG_INTEGER = '数値（整数のみ）';
export const MSG_NUM = '数字';
export const MSG_PHONE_NUM = '数字、及び「-」の組み合わせ';


// ↓ メッセージ一覧取得前にエラーが発生する可能性があるため、定数としています
export const E3003 = 'タイムアウトが発生しました。';
export const E3004 = 'ネットワークエラーが発生しました。再度ログインしてください。';
export const E3005 = '予期しないエラーが発生しました。';
export const E3006 = 'お探しのページが見つかりませんでした。';
export const E0042 = '申込み時点から24時間が経過したため、再度利用者申請を行ってください。';
export const E0074 = 'この利用者登録は既に完了しています。';
export const E0064 = 'クライアント側でエラーが発生しました。';
// ↑